import { render, staticRenderFns } from "./OffersGroups.vue?vue&type=template&id=3f1011ba&scoped=true"
import script from "./OffersGroups.vue?vue&type=script&lang=js"
export * from "./OffersGroups.vue?vue&type=script&lang=js"
import style0 from "./OffersGroups.vue?vue&type=style&index=0&id=3f1011ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1011ba",
  null
  
)

export default component.exports